<script setup>
import { computed } from 'vue';
import DatePicker from './DatePicker.vue';
import { normalizeDateRange } from './datePickerUtils';

const props = defineProps({
  modelValue: {
    type: Object,
    default: () => ({ start: '', end: '' }),
  },
  startLabel: { type: String, default: 'Início' },
  endLabel: { type: String, default: 'Fim' },
  min: { type: String, default: '' },
  max: { type: String, default: '' },
  startMin: { type: String, default: '' },
  startMax: { type: String, default: '' },
  endMin: { type: String, default: '' },
  endMax: { type: String, default: '' },
  disabled: { type: Boolean, default: false },
  message: { type: String, default: '' },
  messageType: {
    type: String,
    default: 'info',
    validator: value => ['info', 'error', 'success'].includes(value),
  },
});

const emit = defineEmits(['update:modelValue']);

const range = computed(() => normalizeDateRange(props.modelValue));

const messageClass = computed(() => ({
  'text-lais-text-helper': props.messageType === 'info',
  'text-lais-danger': props.messageType === 'error',
  'text-lais-success': props.messageType === 'success',
}));

const updateRange = patch => {
  emit('update:modelValue', normalizeDateRange({ ...range.value, ...patch }));
};
</script>

<template>
  <fieldset class="min-w-0">
    <div class="grid gap-3 sm:grid-cols-2">
      <DatePicker
        :model-value="range.start"
        :label="startLabel"
        :min="startMin || min"
        :max="startMax || range.end || max"
        :disabled="disabled"
        @update:model-value="updateRange({ start: $event })"
      />
      <DatePicker
        :model-value="range.end"
        :label="endLabel"
        :min="endMin || range.start || min"
        :max="endMax || max"
        :disabled="disabled"
        @update:model-value="updateRange({ end: $event })"
      />
    </div>
    <p v-if="message" class="mt-2 text-lais-label-sm" :class="messageClass">
      {{ message }}
    </p>
  </fieldset>
</template>
